<template>
  
  <div class="property">
  
    <div class="name">
      <span :class="{ label: isLabel}">
        {{ item.name }}{{ item.value ? ':' : '' }}
      </span>
      <span 
        v-if    = "item.value"
        class   = "value"
      >
        {{ item.value }}
      </span>
    </div>

    <v-tooltip 
      v-if      = "item.tooltip"
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          class   = "ml-2"
          v-bind  = "attrs"
          v-on    = "on"
        >
          mdi-help-circle-outline
        </v-icon>
      </template>
      <span>{{ item.tooltip }}</span>
    </v-tooltip>

  </div>

</template>

<script lang="js">

export default {

  // #region Properties

  name:  'PropertyTreeNode',
  props: {
    item: Object
  },
  computed: {
    isLabel() {
      return this.item.value || !this.item.children;
    }
  }

  // #endregion Properties

}

</script>

<style lang="scss" scoped>

.property {
  display:    flex;
  flex-direction: row;
  .name {
    flex:       1;
  }

  .label {
    color:      rgba(255, 255, 255, 0.5);
  }
}

</style>